import type {
  ReportComponentVisualizationProps,
  ReportDashboardComponent,
} from '@core/reports-types';

export const getComponentVisualizationProps = (
  component: ReportDashboardComponent,
): ReportComponentVisualizationProps | null =>
  component
    ? {
        viewMode: component.viewMode,
        chartType: component.chartType,
        settings: component.settings
          ? {
              ...(component.settings.amountOfDataDisplayed
                ? { amountOfDataDisplayed: component.settings.amountOfDataDisplayed }
                : {}),

              ...(component.settings.localSortBy
                ? { localSortBy: component.settings.localSortBy }
                : {}),

              ...(component.settings.localSortOrder
                ? { localSortOrder: component.settings.localSortOrder }
                : {}),
            }
          : {},
      }
    : null;
